import React, { useEffect, useState } from "react";

import { Table, Input } from "rsuite";
import { debounce, cloneDeep } from "lodash";

import { sortTypes, defaultOnSortColumnHandler } from "./SortByString";
import Pagination from 'rsuite/Pagination';

const TableWithSearch = ({
    dataLoading,
    data,
    setData,
    searchData,
    setSearchData,
    rightContent,
    columnSortHandler,
    debounceDelay,
    onRowClick,
    searchInputPlaceholder,
    applyFilter,
    filtersData,
    searchBy,
    locale,
    isBatchDelete,
    deletedData,
    children,
    actionButtonGroup
}) => {

    const [sortType, setSortType] = useState(sortTypes.desc);
    const [searchFieldValue, setSearchFieldValue] = useState("");
    const [searchedLocations, setSearchedLocations] = useState([]);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [filteredData, setFilteredData] = useState(data);

    const handleChangePage = pageKey => {
        setPage(pageKey)

        const pageData = data.filter((v, i) => {
            const start = limit * (pageKey - 1);
            const end = start + limit;
            return i >= start && i < end;
        });

        setFilteredData(pageData);
    }

    const handleChangeLimit = limitKey => {
        console.log({limitKey});
        setLimit(limitKey);
        setPage(1);

        const pageData = data.filter((v, i) => {
            const start = 0;
            const end = start + limitKey;
            return i >= start && i < end;
        });

        setFilteredData(pageData);
    }

    const controlSearchInput = data => setSearchFieldValue(data);

    const onSortColumn = (fieldName, sortOrder) => {
        console.log({columnSortHandler});
        columnSortHandler ?
            columnSortHandler(fieldName, sortOrder, data, setData, setSortType) :
            defaultOnSortColumnHandler(fieldName, sortOrder, data, setData, setSortType)
    }

    const searchLocationsDebounced = debounce(() => {
        const localData = cloneDeep(data)
            .filter(item => item[searchBy]?.toLowerCase()?.includes(searchFieldValue?.toLowerCase()));
            searchData? setSearchData(localData): setSearchedLocations(localData);
    }, debounceDelay, {})

    useEffect(() => {
        searchLocationsDebounced();
        const pageData = data.filter((v, i) => {
            const start = limit * (page - 1);
            const end = start + limit;
            return i >= start && i < end;
        });

        setFilteredData(pageData);
    }, [data, searchFieldValue])

    return (
        <div className="list">
            <div className="list-search-wrapper">
                <Input
                    disabled={!data.length}
                    type="text"
                    placeholder={searchInputPlaceholder}
                    value={searchFieldValue}
                    onChange={controlSearchInput}
                    size="lg"
                    className="list-search"
                />
                <div className='action-button-group'>
                    {actionButtonGroup}
                </div>
                {rightContent && <div>
                    {rightContent()}
                </div>}
            </div>

            {applyFilter && <div>{filtersData()}</div>}

            {isBatchDelete && <div>{deletedData()}</div>}

            <Table
                loading={dataLoading}
                data={searchFieldValue && (searchData || searchedLocations)? (searchData || searchedLocations) : filteredData}
                autoHeight
                rowHeight={70}
                onSortColumn={onSortColumn}
                sortType={sortType}
                className="list-table"
                onRowClick={onRowClick && onRowClick}
                locale={locale}
                hover={false}
            >
                {children}
            </Table>
            <div style={{ padding: 20 }}>
                <Pagination
                  prev
                  next
                  first
                  last
                  ellipsis
                  boundaryLinks
                  maxButtons={5}
                  size="xs"
                  layout={['total', '-', 'limit', '|', 'pager', 'skip']}
                  total={data.length}
                  limitOptions={[10, 30, 50]}
                  limit={limit}
                  activePage={page}
                  onChangePage={handleChangePage}
                  onChangeLimit={handleChangeLimit}
                />
            </div>
        </div>
    );
};

TableWithSearch.defaultProps = {
    dataLoading: false,
    data: [],
    searchData:null,
    setSearchData: null,
    rightContent: null,
    filtersData: null,
    debounceDelay: 1000,
    setData: null,
    columnSortHandler: null, // should be passed from parent component
    onRowClick: null,
    searchInputPlaceholder: "Search",
    searchBy: "name",
    deletedData: null,
    locale: null
}

export default TableWithSearch;